import React from 'react'

const OneChatOption = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect className='custom-icon-stroke' x="2.3577" y="2.35721" width="19.2857" height="19.2857" rx="2.78571" stroke="white" strokeWidth="1.28571"/>
    </svg>
  )
}

export default OneChatOption
